import VideoBaseController from "./video_base_controller"

// Video preview controller for forms - extends VideoBaseController
// Usage: data-controller="video-preview" 
export default class extends VideoBaseController {
  static targets = ["urlInputWrapper", "urlInput", "previewContainer"]

  connect() {
    this.handleInitialUrl()
  }

  // Handle URL input changes (real-time preview)
  handleUrlInput(event) {
    const url = this.cleanVideoUrl(event.target.value)

    if (url && this.isValidVideoUrl(url)) {
      this.showVideoPreview(url)
    } else {
      this.hideVideoPreview()
    }
  }

  // Handle URL blur (validation + preview)
  handleUrlBlur(event) {
    const url = this.cleanVideoUrl(event.target.value)
    const validation = this.validateVideoUrl(url)

    if (validation.valid) {
      this.showVideoPreview(validation.url)
      this.clearValidationError()
    } else {
      this.hideVideoPreview()
      if (url) { // Only show error if user actually entered something
        this.showValidationError(validation.error)
      }
    }
  }

  // Show video preview
  showVideoPreview(url) {
    const embedUrl = this.getEmbedUrl(url)
    if (!embedUrl) return

    const platform = this.getPlatform(url)
    const title = this.getVideoTitle(url)
    const color = this.getPlatformColor(platform)

    this.previewContainerTarget.innerHTML = this.generatePreviewHtml({
      embedUrl,
      originalUrl: url,
      platform,
      title,
      color
    })

    this.showPreviewContainer()
  }

  // Hide video preview
  hideVideoPreview() {
    this.previewContainerTarget.innerHTML = ''
    this.hidePreviewContainer()
  }

  // Generate complete preview HTML
  generatePreviewHtml({embedUrl, originalUrl, platform, title, color}) {
    return `
        <div class="video-embed-wrapper">
          ${this.generateEmbedHtml(embedUrl, {height: '390'})}
        </div>
    `
  }

  // Handle initial URL if present
  handleInitialUrl() {
    if (this.hasUrlInputTarget && this.urlInputTarget.value) {
      const url = this.cleanVideoUrl(this.urlInputTarget.value)
      if (this.isValidVideoUrl(url)) {
        this.showVideoPreview(url)
      }
    }
  }

  // Remove video and clear input
  removeVideo() {
    if (this.hasUrlInputTarget) {
      this.urlInputTarget.value = ''
    }
    this.hideVideoPreview()
    this.clearValidationError()
  }

  // Show/hide preview container
  showPreviewContainer() {
    this.previewContainerTarget.style.display = 'block'

    if (this.hasUrlInputWrapperTarget) this.urlInputWrapperTarget.classList.add('d-none')
  }

  hidePreviewContainer() {
    this.previewContainerTarget.style.display = 'none'
  }

  // Validation error handling
  showValidationError(message) {
    this.clearValidationError()

    const errorElement = document.createElement('div')
    errorElement.className = 'text-danger small mt-1 video-url-error'
    errorElement.textContent = message

    if (this.hasUrlInputTarget) {
      this.urlInputTarget.insertAdjacentElement('afterend', errorElement)
    }
  }

  clearValidationError() {
    const existingError = document.querySelector('.video-url-error')
    if (existingError) {
      existingError.remove()
    }
  }

  disconnect() {
    this.clearValidationError()
  }
}